import CommonOTSheet from "../../components/common/OTSheet/CommonOTSheet"

const RejectedSheet = () => {
  return (
    <div className="bg-white">
      <CommonOTSheet view_by_status={3} sheet_name="Rejected" />
    </div>
  );
}
export default RejectedSheet